module.exports = __webpack_public_path__ + "static/media/pficon.efcb4963.woff";